module.exports = __webpack_public_path__ + "img/middleA.f9ecd1e1.png";